import { BoxLayout, BoxPanel, Panel, SplitPanel, Widget } from '@theia/core/shared/@lumino/widgets';
import { injectable } from '@theia/core/shared/inversify';
import type { AppSidePanelHandler } from './side-panel-handler';

@injectable()
export class RightPanelContribution {
    protected readonly rightPanelDefaultWidth: number = 480;
    protected readonly rightPanelMinWidth: number = 400;

    createContainer(handler: AppSidePanelHandler): Panel {
        const containerLayout: BoxLayout = new BoxLayout({
            direction: 'top-to-bottom',
            spacing: 0
        });
        const boxPanel: BoxPanel = new BoxPanel({ layout: containerLayout });
        boxPanel.id = 'theia-right-content-panel';
        boxPanel.node.style.minWidth = `${this.rightPanelMinWidth}px`;
        handler.dockPanel.node.style.minWidth = `${this.rightPanelMinWidth}px`;
        handler.dockPanel.mode = 'single-document';

        BoxPanel.setStretch(handler.dockPanel, 1);
        containerLayout.addWidget(handler.dockPanel);
        return boxPanel;
    }

    afterRefresh(handler: AppSidePanelHandler): void {
        for (const tabBar of handler.dockPanel.tabBars()) {
            tabBar.hide();
        }
        handler.container.node.style.minWidth = `${this.rightPanelMinWidth}px`;
        handler.dockPanel.node.style.minWidth = `${this.rightPanelMinWidth}px`;
    }

    getDefaultPanelSize(handler: AppSidePanelHandler): number | undefined {
        const parent = handler.container.parent;
        if (parent instanceof SplitPanel && parent.isVisible) {
            const index: number = parent.widgets.indexOf(handler.container);
            if (index > 0) {
                const centerWidget: Widget = parent.widgets[index - 1];
                const centerWidth: number = Math.round(centerWidget.node.getBoundingClientRect().width);
                if (centerWidth > 0) {
                    return Math.max(this.rightPanelMinWidth, Math.floor(centerWidth / 2));
                }
            }
        }
        return this.rightPanelDefaultWidth;
    }
}
